

























































import { Component, Vue } from "vue-property-decorator";

@Component
export default class NotFound extends Vue {
  get orderNotFound(): boolean {
    return this.$route.query.error === "order";
  }
}
